import type { EditorPlugin } from '../../types/aha-editor';
import { Editor } from 'slate';
import BlockUtils from '../Blocks/BlockUtils';
import AhaEditor from '../../AhaEditor';

const CodeBlockPastePlugin: EditorPlugin = {
  name: 'CodeBlock Paste Plugin',
  insertData: (editor: Editor, data: DataTransfer) => {
    if (data.types.includes(`application/${AhaEditor.clipboardFormatKey}`))
      return false;
    if (!BlockUtils.selectionIsInBlock(editor, 'code')) return false;

    // Always insert as plain text when pasting a code block so we don't
    // include any other styling that conflicts with its own syntax
    // highlighting.
    const text = data.getData('text/plain');
    Editor.insertText(editor, text);

    return true;
  },
};

export default CodeBlockPastePlugin;
